import { Box } from "@mui/material";
import {
  CheckCircle,
  Info,
  Warning,
  XCircle,
} from "@phosphor-icons/react";
import { APP_COLORS } from "../../enums";

const iconSize = 24;
const wrapperSx = {
  width: 32,
  height: 32,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

export function ToastSuccessIcon() {
  return (
    <Box sx={wrapperSx}>
      <CheckCircle
        size={iconSize}
        weight="fill"
        color={APP_COLORS.success}
        style={{ display: "block" }}
      />
    </Box>
  );
}

export function ToastInfoIcon() {
  return (
    <Box sx={wrapperSx}>
      <Info
        size={iconSize}
        weight="fill"
        color={APP_COLORS.info}
        style={{ display: "block" }}
      />
    </Box>
  );
}

export function ToastWarningIcon() {
  return (
    <Box sx={wrapperSx}>
      <Warning
        size={iconSize}
        weight="fill"
        color={APP_COLORS.yellow}
        style={{ display: "block" }}
      />
    </Box>
  );
}

export function ToastErrorIcon() {
  return (
    <Box sx={wrapperSx}>
      <XCircle
        size={iconSize}
        weight="fill"
        color={APP_COLORS.error}
        style={{ display: "block" }}
      />
    </Box>
  );
}
